import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 11.9999L1.32902 11.6648L1.16168 11.9999L1.32902 12.335L2 11.9999ZM22 12L22.671 12.3351L22.8383 12L22.671 11.6649L22 12ZM2 11.9999L2.67098 12.335C4.9893 7.69273 8.55546 5.49997 12 5.5C15.4445 5.50003 19.0107 7.69284 21.329 12.3351L22 12L22.671 11.6649C20.1618 6.64058 16.1417 4.00003 12 4C7.85827 3.99997 3.83815 6.64046 1.32902 11.6648L2 11.9999ZM2 11.9999L1.32902 12.335C3.83815 17.3593 7.85826 19.9999 12 19.9999C16.1417 20 20.1618 17.3595 22.671 12.3351L22 12L21.329 11.6649C19.0107 16.3072 15.4445 18.4999 12 18.4999C8.55547 18.4999 4.9893 16.3071 2.67098 11.6648L2 11.9999ZM15.25 12H14.5C14.5 13.3807 13.3807 14.5 12 14.5V15.25V16C14.2091 16 16 14.2091 16 12H15.25ZM12 15.25V14.5C10.6193 14.5 9.5 13.3807 9.5 12H8.75H8C8 14.2091 9.79086 16 12 16V15.25ZM8.75 12H9.5C9.5 10.6193 10.6193 9.49998 12 9.49998V8.74998V7.99998C9.79086 7.99998 8 9.79084 8 12H8.75ZM12 8.74998V9.49998C13.3807 9.49998 14.5 10.6193 14.5 12H15.25H16C16 9.79084 14.2091 7.99998 12 7.99998V8.74998Z",
		fill: "currentcolor"
	})]
});
export default SvgEye;
